<template>
  <div class="container-fluid py-4">
    <div class="row">
      <PrepostHomeDashSroColumn ref="delivered" title="Entregue" status="delivered" color="bg-gradient-info" icon="ni-user-run" :startedAt="startedAt" :finishedAt="finishedAt" :customer="customer" :services="services" />
      <PrepostHomeDashSroColumn @open="open" ref="devolution" title="Devolução" status="devolution" color="bg-gradient-primary" icon="ni-air-baloon" :startedAt="startedAt" :finishedAt="finishedAt" :customer="customer" :services="services" />
      <PrepostHomeDashSroColumn @open="open" ref="awaiting_withdrawal" title="Retirada" status="awaiting_withdrawal" color="bg-gradient-orange" icon="ni-tag" :startedAt="startedAt" :finishedAt="finishedAt" :customer="customer" :services="services" />
      <PrepostHomeDashSroColumn @open="open" ref="lost" title="Extraviado" status="lost" color="bg-gradient-danger" icon="ni-notification-70" :startedAt="startedAt" :finishedAt="finishedAt" :customer="customer" :services="services" />
    </div>
  </div>
</template>
<script>
import PrepostHomeDashSroColumn from './PrepostHomeDashSroColumn.vue';
export default {
  name: "PrepostHomeDashSro",
  props: ["startedAt", "finishedAt", "customer", "services"],
  components: {
    PrepostHomeDashSroColumn
  },
  methods: {
    fetch() {
      this.$refs.delivered.fetch();
      this.$refs.devolution.fetch();
      this.$refs.awaiting_withdrawal.fetch();
      this.$refs.lost.fetch();
    },
    open(status) {
      console.log('open emit', status)
      this.$emit('open', status);
    }
  }

}
</script>
<style scoped>
.item-badge {
  margin-top: 10px;
  margin-right: 40px;  
}
.discount {
  width: 80px !important;
}
form {
  margin-top: 20px;
}
@media screen and (min-width: 458px) {
  .col-form-label {
    text-align: right;
  }
}
.el-date-editor--date {
  width: 140px !important;
}
.ni {
  color: #fff;
}
.txt-12 {
  font-size: 12px;
}
</style>
